import React from 'react';
import { isAdmin } from '../utils';

export default function MobileMenuPage({
    user,
    userProfile,
    navigateToPage,
    currentPage,
    handleLogout,
    memorizationProgress = {},
    memorizationTexts = [],
    devotionals = []
}) {
    const menuItems = [
        { page: 'home', title: 'Home', icon: '🏠', description: 'Dashboard and progress overview', color: 'from-indigo-500 to-blue-500' },
        { page: 'essentials', title: 'MG Essentials', icon: '📋', description: 'Pledge, Law, Motto, and Song', color: 'from-purple-500 to-violet-500' },
        { page: 'devotionals', title: 'Devotional Journal', icon: '📖', description: 'Personal spiritual journal', color: 'from-emerald-500 to-green-500' },
        { page: 'study-resources', title: 'Study Resources', icon: '📚', description: 'Bible Truths, Beliefs & Heritage', color: 'from-orange-500 to-red-500' },
        { page: 'honours', title: 'Honours & Skills', icon: '🎯', description: 'Track your achievements', color: 'from-pink-500 to-rose-500' },
    ];

    if (isAdmin(user)) {
        menuItems.push({
            page: 'admin',
            title: 'Admin Dashboard',
            icon: '⚙️',
            description: 'Manage app content',
            color: 'from-gray-500 to-slate-500'
        });
    }

    return (
        <div className="max-w-2xl mx-auto">
            <div className="text-center mb-8">
                <div className="inline-flex items-center px-6 py-3 rounded-full bg-gradient-to-r from-indigo-100 to-purple-100 text-indigo-800 font-medium mb-4">
                    <span className="mr-2">👋</span>
                    Welcome, {userProfile?.name}!
                </div>
                <h2 className="text-3xl font-bold text-gray-900 mb-2">Master Guide</h2>
                <p className="text-gray-600">Navigate to any section to continue your journey</p>
            </div>

            <div className="space-y-4">
                {menuItems.map((item) => (
                    <button
                        key={item.page}
                        onClick={() => navigateToPage(item.page)}
                        className={`group w-full p-6 text-left bg-white rounded-2xl shadow-lg border transition duration-300 hover:shadow-xl hover:scale-105 ${currentPage === item.page ? 'border-indigo-300 bg-gradient-to-r from-indigo-50 to-purple-50' : 'border-gray-200 hover:border-gray-300'
                            }`}
                    >
                        <div className="flex items-center space-x-4">
                            <div className={`w-16 h-16 bg-gradient-to-br ${item.color} rounded-2xl flex items-center justify-center group-hover:scale-110 transition duration-300`}>
                                <span className="text-white text-2xl">{item.icon}</span>
                            </div>
                            <div className="flex-1">
                                <h3 className="font-bold text-gray-900 text-lg mb-1">{item.title}</h3>
                                <p className="text-sm text-gray-600">{item.description}</p>
                            </div>
                            <div className="text-gray-400 group-hover:text-indigo-600 transition duration-300">
                                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                                </svg>
                            </div>
                        </div>
                    </button>
                ))}
            </div>

            <div className="mt-8 bg-gradient-to-r from-indigo-600 via-purple-600 to-blue-600 rounded-2xl p-6 text-white">
                <h3 className="font-bold text-xl mb-4 flex items-center">
                    <span className="mr-3">📊</span>
                    Your Progress Overview
                </h3>
                <div className="grid grid-cols-2 gap-6">
                    <div className="text-center">
                        <div className="text-2xl font-bold mb-1">
                            {Object.values(memorizationProgress).filter(Boolean).length}
                        </div>
                        <div className="text-sm opacity-90">Verses Memorized</div>
                        <div className="w-full bg-white/20 rounded-full h-2 mt-2">
                            <div
                                className="bg-white h-2 rounded-full transition-all duration-500"
                                style={{ width: `${Math.min((Object.values(memorizationProgress).filter(Boolean).length / Math.max(memorizationTexts.length, 1)) * 100, 100)}%` }}
                            ></div>
                        </div>
                    </div>
                    <div className="text-center">
                        <div className="text-2xl font-bold mb-1">
                            {devotionals.length}
                        </div>
                        <div className="text-sm opacity-90">Journal Entries</div>
                        <div className="text-xs opacity-75 mt-1">
                            {devotionals.length > 0 ?
                                `Latest: ${new Date(devotionals[0]?.date?.seconds * 1000).toLocaleDateString()}` :
                                'Start your first entry!'
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-6 text-center">
                <button
                    onClick={handleLogout}
                    className="text-gray-500 hover:text-gray-700 font-medium transition duration-300"
                >
                    Sign Out
                </button>
            </div>
        </div>
    );
}
